"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setSendTypingIndicator;
exports.SET_SEND_TYPING_INDICATOR = void 0;
var SET_SEND_TYPING_INDICATOR = 'WEB_CHAT/SET_SEND_TYPING_INDICATOR';
exports.SET_SEND_TYPING_INDICATOR = SET_SEND_TYPING_INDICATOR;

function setSendTypingIndicator(value) {
  return {
    type: SET_SEND_TYPING_INDICATOR,
    payload: {
      sendTypingIndicator: !!value
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldFNlbmRUeXBpbmdJbmRpY2F0b3IuanMiXSwibmFtZXMiOlsiU0VUX1NFTkRfVFlQSU5HX0lORElDQVRPUiIsInNldFNlbmRUeXBpbmdJbmRpY2F0b3IiLCJ2YWx1ZSIsInR5cGUiLCJwYXlsb2FkIiwic2VuZFR5cGluZ0luZGljYXRvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLHlCQUF5QixHQUFHLG9DQUFsQzs7O0FBRWUsU0FBU0Msc0JBQVQsQ0FBZ0NDLEtBQWhDLEVBQXVDO0FBQ3BELFNBQU87QUFDTEMsSUFBQUEsSUFBSSxFQUFFSCx5QkFERDtBQUVMSSxJQUFBQSxPQUFPLEVBQUU7QUFBRUMsTUFBQUEsbUJBQW1CLEVBQUUsQ0FBQyxDQUFDSDtBQUF6QjtBQUZKLEdBQVA7QUFJRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNFVF9TRU5EX1RZUElOR19JTkRJQ0FUT1IgPSAnV0VCX0NIQVQvU0VUX1NFTkRfVFlQSU5HX0lORElDQVRPUic7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNldFNlbmRUeXBpbmdJbmRpY2F0b3IodmFsdWUpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRVRfU0VORF9UWVBJTkdfSU5ESUNBVE9SLFxuICAgIHBheWxvYWQ6IHsgc2VuZFR5cGluZ0luZGljYXRvcjogISF2YWx1ZSB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFNFVF9TRU5EX1RZUElOR19JTkRJQ0FUT1IgfTtcbiJdfQ==